<div *ngIf="heading" class="phx-menu-header">
  <span class="phx-menu-header-back-button" phx-icon [phxIcon]="ArrowLeft" (click)="goBack($event)" ></span>
  <span *ngIf="!!heading">{{ heading }}</span>
</div>
<ng-content></ng-content>
